// extracted by mini-css-extract-plugin
export default {"table":"Nudge_table__s0uC6","leftcolumn":"Nudge_leftcolumn__Tdau3","rightcolumn":"Nudge_rightcolumn__uEPvk","columncontent":"Nudge_columncontent__vdrRk"};